module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-page-layout', {
    attrs: {
      "config": _vm.pageConfig
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.IsLoading),
      expression: "IsLoading"
    }],
    attrs: {
      "element-loading-text": "加载中",
      "data": [_vm.Order]
    }
  }, [_c('el-row', [_c('el-table-column', {
    attrs: {
      "label": "租赁订单",
      "prop": "Code"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "发货类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("RentalOrderDeliveryType")(props.row.ShipmentType)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("RentalOrderOrderType")(props.row.OrderType)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单押金"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("amount")(props.row.PledgeAmount)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保修费用"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("amount")(props.row.WarrantyAmount)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单租金"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("amount")(props.row.TotalRentalAmount)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "客户合同编号",
      "prop": "CustomerContractCode"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "区域",
      "prop": "RegionName"
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "客户订单号："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.CustomerOrderCode))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系人："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ImmediateDeliveryContactName))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系人电话："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.ImmediateDeliveryContactPhone))])]), _vm._v(" "), _c('el-form-item', {
          attrs: {
            "label": "联系人地址："
          }
        }, [_c('span', [_vm._v("\n                " + _vm._s(props.row.ImmediateDeliveryProvinceName) + "\n                " + _vm._s(props.row.ImmediateDeliveryCityName) + "\n                " + _vm._s(props.row.ImmediateDeliveryCountyName) + "\n                " + _vm._s(props.row.ImmediateDeliveryAddress) + "\n              ")])]), _vm._v(" "), _c('el-form-item', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "label": "客户订单备注："
          }
        }, [_c('span', [_vm._v(_vm._s(props.row.CustomerNotes))])])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('h3', {
    staticStyle: {
      "line-height": "3em"
    }
  }, [_vm._v("物料清单")]), _vm._v(" "), _c(_vm.currentTable, {
    tag: "component",
    attrs: {
      "list": _vm.Order.ProductLines,
      "order-id": _vm.Order.OrderId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77a53ed2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/LeaseDetailPage.vue
// module id = 754
// module chunks = 0